import { render, staticRenderFns } from "./ProvinceDataSourceDashboard.vue?vue&type=template&id=6edb4625&"
import script from "./ProvinceDataSourceDashboard.vue?vue&type=script&lang=js&"
export * from "./ProvinceDataSourceDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ProvinceDataSourceDashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports